import { useEffect, useState, useCallback } from 'react'
import { showToast } from '@provi/provi-components'
import { cancellationUpdateRequest, getCancellation, updateRefundInformation } from '../../services/api'
import { logger } from '../../utils/logger'
import { getRefundStatusType } from '../../utils/getRefundStatusType'
import { toast } from 'react-toastify'

export const useRequests = ({ cridInfo, closeModalGiveup, refetchParentData }) => {
  const [cancellationData, setCancellationData] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [isLoadingCancellationData, setIsLoadingCancellationData] = useState(false)
  const objRefundType = {
    wirecard:
      cridInfo?.ProductType === 'Pix'
        ? 'Reembolso por estorno na conta utilizada para pagamento'
        : 'Reembolso por estorno no cartão de crédito',
    starkbank: 'Reembolso por depósito em conta',
    'ordem de pagamento': ' Reembolso por ordem de pagamento',
    pix: 'Reembolso por Pix'
  }

  const getCancelationData = useCallback(async () => {
    if (!cridInfo?.id) return
    try {
      setIsLoadingCancellationData(true)
      const data = await getCancellation(cridInfo.id)

      setCancellationData(data)
      setIsLoadingCancellationData(false)
    } catch (error) {
      showToast()
      setIsLoadingCancellationData(false)
    }
  }, [cridInfo?.id])

  useEffect(() => {
    getCancelationData()
  }, [getCancelationData])

  const onSubmit = async () => {
    try {
      setIsLoading(true)
      if (cridInfo.id) {
        await cancellationUpdateRequest(cridInfo.id, {
          status: 'canceled',
          studentAnswer: true,
          CancellationRequestId: cancellationData?.cancellationRequest?.id
        })

        if (cancellationData) {
          setCancellationData({
            ...cancellationData,
            cancellationRequest: {
              ...cancellationData.cancellationRequest,
              status: 'canceled'
            }
          })
        }

        setIsLoading(false)
        if (closeModalGiveup) {
          closeModalGiveup()
        }

        // Trigger parent refetch to update StatusChip
        if (refetchParentData) {
          refetchParentData()
        }
      }
    } catch (error) {
      logger(error)
      showToast()
      setIsLoading(false)
    }
  }

  const refundFlowStatus = getRefundStatusType(cancellationData)

  return {
    objRefundType,
    onSubmit,
    cancellationData,
    refundFlowStatus,
    isLoading,
    isLoadingCancellationData,
    refetchCancellationData: getCancelationData
  }
}

export const usePixKeyUpdate = CancellationRequestId => {
  const [isLoading, setIsLoading] = useState(false)

  const submitPixInfo = async ({ pixKey, pixType, recipient, CPF, thirdPartyRecipient }) => {
    try {
      setIsLoading(true)
      await updateRefundInformation({ CancellationRequestId, pixKey, pixType, recipient, CPF, thirdPartyRecipient })
      toast.success('Dados de PIX enviados com sucesso', { containerId: 'TOP' })
    } catch (e) {
      logger(e)
      toast.error('Falha ao enviar dados do PIX', { containerId: 'TOP' })
    } finally {
      setIsLoading(false)
    }
  }

  return { submitPixInfo, isLoading }
}
